// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import EquatorialGuinea from '../_raw/flag/icon_flag_equatorial_guinea.png';

export default () => <img src={EquatorialGuinea} alt="EquatorialGuinea" />;
